import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'

export const SectionWrapperStyled = styled(SectionWrapper)`
  border-radius: ${p => p.theme.blocks.blockBorderRadius};
  background: ${p => p.theme.colors.catskillWhite};
`
